import * as showdown from 'showdown';

import isEmpty from 'lodash-es/isEmpty';

export interface Substitution {
  key: string;
  name: string;
}

export interface CustomInformation {
  body: string;
  subject: string;
  substitutions?: { key: string; name: string; translationUnit?: string }[];
}

export const converter = new showdown.Converter({
  emoji: true,
  openLinksInNewWindow: true,
  simpleLineBreaks: true,
  simplifiedAutoLink: true,
});
converter.setFlavor('ghost');

export function replaceSubstitutionsFromMentions(
  text: string,
  substitutions: Substitution[],
) {
  if (isEmpty(text)) {
    return '';
  }
  return substitutions.reduce(
    (result, { key, name }) =>
      result.replace(new RegExp(`@${key}`, 'ig'), name),
    text,
  );
}

export function convertToQuillMarkdownFormat(content = '') {
  return content.replace(
    /<span[\s\S]*?>([\s\S]*?)<\/span>/g,
    (match, capture) => capture,
  );
}

export function trimWhiteSpaceInEmphasizedElement(htmlString: string) {
  const emphasizedElementsRegexes = [
    /(<strong\b[^>]*>)(\s+)/g,
    /(<strong>)(\s+)/g,
    /(\s+)(<\/strong>)/g,
    /(<em\b[^>]*>)(\s+)/g,
    /(<em>)(\s+)/g,
    /(\s+)(<\/em>)/g,
  ];
  let modifiedString = htmlString;
  emphasizedElementsRegexes.forEach((regex) => {
    const matches = htmlString.matchAll(regex);
    for (const [match, group1, group2] of matches) {
      const replacement = `${group2}${group1}`;
      modifiedString = modifiedString.replace(match, replacement);
    }
  });
  return modifiedString;
}

export function makeMarkdownFromHtml(htmlString: string) {
  return convertToQuillMarkdownFormat(
    fixShowdownUnderlineIssues(
      converter.makeMarkdown(trimWhiteSpaceInEmphasizedElement(htmlString)),
    ),
  );
}

export function fixShowdownUnderlineIssues(markdownString: string): string {
  const underlineIssueRegexes = [
    /(\*\*<u>.*?<\/u>)\n\n\*\*/gm,
    /(\*<u>.*?<\/u>)\n\n\*/gm,
    /(<u>.*?<\/u>)\n\n[ \t]/gm,
    /(<u>.*?<\/u>)\n\n\xa0/gm,
    /\[<u>.*?<\/u>\n\n\]/gm,
  ];
  let modifiedString = markdownString;
  underlineIssueRegexes.forEach((regex) => {
    const matches = modifiedString.matchAll(regex);
    for (const [match] of matches) {
      const replacement = match.replace(/<\/u>\n\n/, '</u>');
      modifiedString = modifiedString.replaceAll(match, replacement);
    }
  });
  return modifiedString;
}

export function makeHtmlFromMarkdown(markdownString: string) {
  return trimWhiteSpaceInEmphasizedElement(
    converter.makeHtml(convertToQuillMarkdownFormat(markdownString)),
  );
}
